enum BannerLocation {
    dashboard = 'DASHBOARD',
    pointsInformations = 'POINTS_INFORMATIONS',
}

export default BannerLocation;
